module.exports = "<hybse-admin-add-ibo [actionType]=\"'edit'\"></hybse-admin-add-ibo>"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/ibo/update-ibo/update-ibo.component.html
// module id = ../../../../../src/app/components/pages/ibo/update-ibo/update-ibo.component.html
// module chunks = main